import {Injectable} from '@angular/core';
import {
  HttpRequest,
  HttpHandler,
  HttpEvent,
  HttpInterceptor
} from '@angular/common/http';
import {Observable, from} from 'rxjs';
import {mergeMap} from 'rxjs/operators';
import {AuthService} from './auth.service';
import {Auth} from 'aws-amplify';

@Injectable()
export class HeaderInterceptor implements HttpInterceptor {

  constructor() {
  }

  intercept(request: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
    return from(Auth.currentAuthenticatedUser()
      .catch(_ => null)
      .then(usr => {
        if (usr == null) {
          return null;
        } else {
          return Auth.currentSession();
        }
      }))
      .pipe(
        mergeMap(session => {
          if (session != null) {
            const businessProfile = JSON.parse(localStorage.getItem(AuthService.BusinessProfileKey));
            if (businessProfile?.id) {
              request = request.clone({
                setHeaders: {
                  Authorization: session.getIdToken().getJwtToken(),
                  'business-profile-id': businessProfile.id
                }
              });
            } else {
              request = request.clone({
                setHeaders: {
                  Authorization: session.getIdToken().getJwtToken(),
                  'Content-Type': 'application/json'
                }
              });
            }
          }
          return next.handle(request);
        })
      );
  }
}
